import React from 'react';
import { Button, IconButton, useMediaQuery, useDisclosure } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getIsPageBarOpen } from 'redux/DashboardSliceV2';
import FigmaFileDownloadIcon from 'components/Icons/FigmaFileDownloadIcon';
import { isReportPacksEnabled } from 'utils/reportPacksFlag';
import {
  accent,
  controlHeight,
  font,
  fontSize,
  neutral,
  radius,
  text as textToken,
} from 'styles/revampTokens';

import DashboardExportPanel from './DashboardExportPanel';
import PreviewModal from './PreviewModal';

const ExportButtonNew = () => {
  const flags = useFlags();
  const isPageBarOpen = useSelector(getIsPageBarOpen);
  const [smallDevice] = useMediaQuery('(max-width: 1100px)');
  const isSmallDevice = (smallDevice && isPageBarOpen) || smallDevice;
  const { isOpen: isExportOpen, onOpen: onExportOpen, onClose: onExportClose } = useDisclosure();
  const serverPackExport = isReportPacksEnabled(flags);

  const openExport = () => onExportOpen();

  return (
    <>
      {isSmallDevice ? (
        <IconButton
          aria-label='Export'
          icon={<FigmaFileDownloadIcon width={14} height={14} color={accent.solid} />}
          backgroundColor={neutral.surface}
          border={`1px solid ${neutral.border}`}
          borderRadius={radius.control}
          height={controlHeight}
          fontSize={fontSize.body}
          fontWeight='500'
          fontFamily={font.body}
          width='fit-content'
          title='Export'
          padding='0 14px'
          color={textToken.primary}
          _hover={{ backgroundColor: neutral.surfaceHover }}
          onClick={openExport}
        />
      ) : (
        <Button
          backgroundColor={neutral.surface}
          border={`1px solid ${neutral.border}`}
          borderRadius={radius.control}
          height={controlHeight}
          leftIcon={<FigmaFileDownloadIcon width={14} height={14} color={accent.solid} />}
          fontSize={fontSize.body}
          fontWeight='500'
          fontFamily={font.body}
          width='fit-content'
          title='Export'
          padding='0 14px'
          color={textToken.primary}
          _hover={{ backgroundColor: neutral.surfaceHover }}
          onClick={openExport}
        >
          Export
        </Button>
      )}

      {serverPackExport ? (
        <DashboardExportPanel isOpen={isExportOpen} onClose={onExportClose} />
      ) : (
        <PreviewModal isOpen={isExportOpen} onClose={onExportClose} selectedPages={[]} />
      )}
    </>
  );
};

export default ExportButtonNew;
